import type { LessonAwardInstrument } from "@wmf/shared/studentAwards";
import { instrumentArtwork } from "./instrumentArtwork.js";

/** Vector artwork, fitted inside the lesson shield. */
export function LessonInstrumentSymbol({ instrument, cutout }: { instrument: LessonAwardInstrument; cutout: string }) {
  if (instrument === "music-theory") return <>
    <path d="M57 55q22-10 43 3 21-13 43-3v53q-22-10-43 3-21-13-43-3Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round"/>
    <path d="M100 58v53" fill="none" stroke="currentColor" strokeWidth="3"/>
    {[64, 71, 78, 85, 92].map(y => <path key={y} d={"M67 " + y + "h23m20 0h23"} fill="none" stroke="currentColor" strokeWidth="2"/>)}
  </>;
  const artwork = instrumentArtwork[instrument];
  return <svg x="42" y="32" width="116" height="96" viewBox={artwork.viewBox} preserveAspectRatio="xMidYMid meet" stroke="none">
    {artwork.paths.map((path, i) => <path key={i} d={path.d} fill={path.colour === "cutout" ? cutout : "currentColor"}/>)}
  </svg>;
}
